(function () {
  document.querySelectorAll('[data-cart-quantity]').forEach(function (control) {
    var input = control.querySelector('input');
    var minus = control.querySelector('[data-qty-minus]');
    var plus = control.querySelector('[data-qty-plus]');

    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = Math.max(0, Number(input.value || 0) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        input.value = Number(input.value || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

})();
